import React from "react"
import PropTypes from "prop-types"

import { barPercent } from "../useConfigs"

const ClientRow = ({ cliente, onChange, onToggleSeleccion }) => {
  const desde = barPercent(cliente.inicio)
  const hasta = barPercent(cliente.fin)

  const clases = [
    "cfg-row",
    "cfg-row-body",
    cliente.selected ? "is-selected" : "",
    cliente.isDirty ? "is-dirty" : "",
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <div className={clases}>
      <input
        type="checkbox"
        className="cfg-check"
        checked={cliente.selected}
        onChange={() => onToggleSeleccion(cliente.id)}
      />

      <div style={{ minWidth: 0 }}>
        <div className="cfg-client-name">{cliente.nombre}</div>
        <div className="cfg-client-tags">
          {cliente.isDirty && (
            <span className="cfg-tag cfg-tag-warn">Modificado</span>
          )}
          {cliente.invalid && (
            <span className="cfg-tag cfg-tag-error">Revisar horario</span>
          )}
        </div>
      </div>

      <div className="cfg-times">
        <input
          type="time"
          className="cfg-time-cell"
          value={cliente.inicio}
          onChange={event =>
            onChange(cliente.id, { inicio: event.target.value })
          }
        />
        <span>a</span>
        <input
          type="time"
          className="cfg-time-cell"
          value={cliente.fin}
          onChange={event => onChange(cliente.id, { fin: event.target.value })}
        />
      </div>

      <div className="cfg-bar-cell">
        <div className="cfg-bar-track">
          <div
            className={`cfg-bar-fill${cliente.invalid ? " is-invalid" : ""}`}
            style={{
              left: `${desde}%`,
              width: `${Math.max(1.5, hasta - desde)}%`,
            }}
          />
        </div>
        <span className="cfg-bar-value">{cliente.duracion}</span>
      </div>

      <div className="cfg-fee">
        <span className="cfg-fee-prefix">$</span>
        <input
          type="number"
          min="0"
          step="0.1"
          className="cfg-fee-input"
          value={cliente.comision}
          onChange={event =>
            onChange(cliente.id, { comision: event.target.value })
          }
        />
      </div>
    </div>
  )
}

ClientRow.propTypes = {
  cliente: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onToggleSeleccion: PropTypes.func.isRequired,
}

const ClientsTable = ({
  list,
  todosSeleccionados,
  onToggleTodos,
  onChange,
  onToggleSeleccion,
}) => (
  <div className="cfg-scroll">
    <div className="cfg-grid">
      <div className="cfg-row cfg-row-head">
        <input
          type="checkbox"
          className="cfg-check"
          checked={todosSeleccionados}
          onChange={onToggleTodos}
        />
        <div>Cliente</div>
        <div>Ventana de pedido</div>
        <div>06:00 — 23:00</div>
        <div className="text-end">Comisión / unidad</div>
      </div>

      {list.length === 0 && (
        <div className="cfg-empty">
          Ningún cliente coincide con la búsqueda.
        </div>
      )}

      {list.map(cliente => (
        <ClientRow
          key={cliente.id}
          cliente={cliente}
          onChange={onChange}
          onToggleSeleccion={onToggleSeleccion}
        />
      ))}
    </div>
  </div>
)

ClientsTable.propTypes = {
  list: PropTypes.array.isRequired,
  todosSeleccionados: PropTypes.bool,
  onToggleTodos: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onToggleSeleccion: PropTypes.func.isRequired,
}

export default ClientsTable
